"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _mobileNavbar = require("./mobileNavbar");

var _mobileNavbar2 = _interopRequireDefault(_mobileNavbar);

var _reactRouterDom = require("react-router-dom");

var _styled = require("./styled.Header");

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var SmartHeader = function SmartHeader(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var newProps = _extends({}, _defaultProps2.default.props, props);
  var style = newProps.style,
      content = newProps.content,
      media = newProps.media,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode,
      links = newProps.links;


  var linksStyleProps = {
    navColor: getPropValue("text", "navColor", style.navColor, "style"),
    navFont: getPropValue("text", "navFont", style.navFont, "style"),
    fontWeight: getPropValue("text", "fontWeight", style.fontWeight, "style"),
    navHoverColor: getPropValue("text", "navHoverColor", style.navHoverColor, "style"),
    textTransform: getPropValue("text", "textTransform", style.textTransform, "style")
  };

  var link1 = getPropValue("text", "link1", links.link1, "content");
  var url1 = getPropValue("text", "url1", links.url1, "content");
  var link2 = getPropValue("text", "link2", links.link2, "content");
  var url2 = getPropValue("text", "url2", links.url2, "content");
  var link3 = getPropValue("text", "link3", links.link3, "content");
  var url3 = getPropValue("text", "url3", links.url3, "content");
  var logo = getPropValue("text", "logo", media.logo, "media");
  var logoAlt = getPropValue("text", "logoAlt", media.logoAlt, "media");

  var title = getPropValue("text", "title", content.title, "content");
  var bannerContent = getPropValue("text", "content", content.content, "content");
  var buttonTitle = getPropValue("text", "buttonTitle", links.buttonTitle, "content");
  var buttonUrl = getPropValue("text", "buttonUrl", links.buttonUrl, "content");

  var titleStyle = {
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style"),
    bottomSpace: getPropValue("text", "bottomSpace", style.bottomSpace, "style")
  };
  var buttonStyle = {
    buttonColor: getPropValue("text", "buttonColor", style.buttonColor, "style"),
    buttonFontSize: getPropValue("text", "buttonFontSize", style.buttonFontSize, "style"),
    borderColor: getPropValue("text", "borderColor", style.borderColor, "style"),
    buttonHoverColor: getPropValue("text", "buttonHoverColor", style.buttonHoverColor, "style"),
    borderHoverColor: getPropValue("text", "borderHoverColor", style.borderHoverColor, "style"),
    buttonRadius: getPropValue("text", "buttonRadius", style.buttonRadius, "style")
  };
  var paragraphStyle = {
    contentSpace: getPropValue("text", "contentSpace", style.contentSpace, "style")
  };
  var bannerProps = {
    bgImage: getPropValue("text", "bgImage", media.bgImage, "style")
  };
  return _react2.default.createElement(
    _styled.Banner,
    bannerProps,
    _react2.default.createElement(
      _reactRouterDom.BrowserRouter,
      null,
      _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(
          _styled.StyledHeader,
          {
            stickyHeader: true,
            className: "header",
            headerBg: style.background
          },
          _react2.default.createElement(
            _reactBootstrap.Container,
            null,
            _react2.default.createElement(
              _reactBootstrap.Navbar,
              { collapseOnSelect: true, expand: "lg", variant: "dark" },
              _react2.default.createElement(
                _reactRouterDom.NavLink,
                { to: "/", className: "logo p-0" },
                _react2.default.createElement(_styled.LogoImg, { src: logo, alt: logoAlt })
              ),
              _react2.default.createElement(
                _styled.MenuIcon,
                {
                  onClick: function onClick() {
                    return setMenuOpen(!isMenuOpen);
                  },
                  className: "d-flex flex-column justify-content-between d-lg-none"
                },
                _react2.default.createElement("i", { className: "menu-line d-block w-100" }),
                _react2.default.createElement("i", { className: "menu-line d-block w-100" }),
                _react2.default.createElement("i", { className: "menu-line d-block w-75 ml-auto" })
              ),
              _react2.default.createElement(
                _reactBootstrap.Navbar.Collapse,
                { id: "responsive-navbar-nav" },
                _react2.default.createElement(
                  "span",
                  { className: "close-menu position-absolute  d-lg-none" },
                  _react2.default.createElement("i", { className: "fa fa-times-circle", "aria-hidden": "true" }),
                  "close"
                ),
                _react2.default.createElement(
                  _reactBootstrap.Nav,
                  { as: "ul", className: "ml-auto" },
                  _react2.default.createElement(
                    _styled.StyledLi,
                    linksStyleProps,
                    !!link1 && _react2.default.createElement(
                      _reactRouterDom.NavLink,
                      { className: "nav-link", to: "/home" },
                      link1
                    )
                  ),
                  _react2.default.createElement(
                    _styled.StyledLi,
                    linksStyleProps,
                    !!link2 && _react2.default.createElement(
                      _reactRouterDom.NavLink,
                      { className: "nav-link", to: "/enterprise" },
                      link2
                    )
                  ),
                  _react2.default.createElement(
                    _styled.StyledLi,
                    linksStyleProps,
                    !!link3 && _react2.default.createElement(
                      _reactRouterDom.NavLink,
                      { className: "nav-link", to: "/pricing" },
                      link3
                    )
                  )
                )
              )
            ),
            isMenuOpen ? _react2.default.createElement(_styled.Overlay, { onClick: function onClick() {
                return setMenuOpen(false);
              } }) : isMenuOpen,
            _react2.default.createElement(
              _mobileNavbar2.default,
              { navbarShow: isMenuOpen },
              _react2.default.createElement(
                "span",
                {
                  className: "close-menu position-absolute  d-lg-none",
                  onClick: function onClick() {
                    return setMenuOpen(false);
                  }
                },
                _react2.default.createElement("i", { className: "fa fa-times-circle", "aria-hidden": "true" })
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "banner" },
      _react2.default.createElement(
        _styled.BannerContent,
        { className: "content" },
        _react2.default.createElement(
          _styled.Title,
          titleStyle,
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "title",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: title
          })
        ),
        _react2.default.createElement(
          _styled.Paragraph,
          paragraphStyle,
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "content",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: bannerContent
          })
        ),
        !!buttonTitle && _react2.default.createElement(
          _styled.BannerLink,
          _extends({}, buttonStyle, { href: buttonUrl }),
          buttonTitle
        )
      )
    )
  );
};

exports.default = SmartHeader;